import { createSlice } from '@reduxjs/toolkit';

const MenuDaySlice = createSlice({
    name: 'menuDay',
    initialState: { dayNumber: 1 },
    reducers: {
        setDayNumber(state, { payload }) {
            state.dayNumber = payload.dayNumber;
        },
    },
});

export default MenuDaySlice.reducer;
export const { setDayNumber } = MenuDaySlice.actions;
